export const getLocation = async () => {
    return new Promise((resolve, reject) => {

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude, accuracy } = position.coords;

            resolve ({
              latitude,
              longitude,
              precisaoMetros: accuracy
            })
          },
          (error) => {
            console.error("Erro ao obter localização:", error.message);

            resolve({
              latitude: null,
              longitude: null,
              precisaoMetros: null
            })
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        console.error("Geolocation não é suportado pelo seu navegador.");
        resolve({
          latitude: null,
          longitude: null,
          precisaoMetros: null
        });
      }
    });
  }